import { CATALOG_TYPES } from './catalog';

export default {
  name: 'Series',
  catalogType: CATALOG_TYPES.LS,
  id: 'series',
  isTopLevel: true,
};
